/* eslint-disable import/order */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducers as authenticationReducer } from '@saucelabs/sl-container-authentication';
import { reducers as confirmAlertReducer } from '@saucelabs/sl-container-confirm-alert';
import { reducers as notificationsReducer } from '@saucelabs/sl-container-notifications';
import { reducers as permissionsReducer } from '@saucelabs/sl-container-permissions';
import { reducers as sidebarReducer } from '@saucelabs/sl-container-sidebar';
import { reducers as modalReducer } from '@saucelabs/sl-container-modal';
import { reducers as toolbarReducer } from '@saucelabs/sl-container-toolbar';
import { reducers as errorPagesReducer } from '@saucelabs/sl-container-error-pages';
import { reducers as concurrencyReducer } from '@saucelabs/sl-module-concurrency';
import { reducers as experimentsReducer } from '@saucelabs/sl-module-experiments';
import { reducers as userTunnelsReducer } from '@saucelabs/sl-module-tunnels';
import { reducers as userReducer } from '@saucelabs/sl-module-user';
import { reducers as userRdcReducer } from '@saucelabs/sl-module-user-rdc';
import { reducers as performanceReducer } from '@saucelabs/sl-module-performance';
import { reducers as tableReducer } from '@saucelabs/sl-container-table';
import { reducers as announcementsReducer } from '@saucelabs/sl-container-announcements';

import applicationReducer from './application/reducers';

const apps = combineReducers({
  analytics: () => ({}),
  app: applicationReducer,
  archives: () => ({}),
  auth: () => ({}),
  billing: () => ({}),
  builds: () => ({}),
  extendedDebugging: () => ({}),
  healthCheck: () => ({}),
  invitations: () => ({}),
  job: () => ({}),
  jobs: () => ({}),
  manual: () => ({}),
  performance: performanceReducer,
  teamManagement: () => ({}),
  tunnels: () => null,
});

const createReducer = (history) => combineReducers({
  // react & redux 3rd party libs
  router: connectRouter(history),

  // cross package stuff
  confirmedAlerts: confirmAlertReducer,
  modal: modalReducer,
  notifications: notificationsReducer,
  sidebar: sidebarReducer,
  errorPage: errorPagesReducer,
  toolbar: toolbarReducer,
  table: tableReducer,
  announcements: announcementsReducer,

  // FIXME: should be cleaned and moved into `me` key at the top level of store
  // currently logged user
  experiments: experimentsReducer,
  permissions: permissionsReducer,
  user: authenticationReducer,
  userRdc: userRdcReducer,
  userData: userReducer,
  userConcurrency: concurrencyReducer,
  userTunnels: userTunnelsReducer,

  // packages specific store
  apps,
});

export default createReducer;
